class CollapsibleSectionNavigation {
    constructor(sections, config) {
        this.sections = sections;
        this.config = config;
    }

    init() {
        this._createCollapsibleSections();
        this._hideSubSections();
    }

    _createCollapsibleSections() {
        const liElements = this.sections.querySelectorAll('li');
        let cnt = 0;
        liElements.forEach(li => {
            cnt++;
            const ul = li.querySelector('ul');
            if (ul) {
                const a = li.querySelector('a');
                const button = this._createCollapseButton(ul, a?.textContent, 'ul-' + cnt);
                li.insertBefore(button, ul);
                li.classList.add('has-menu');
                button.addEventListener('click', () => this._toggleCollapseButton(button));
                button.addEventListener('keydown', e => this._onButtonKeydown(e));
                button.addEventListener(
                    'transitionend',
                    () => (ul.style.display = this.isAriaExpanded(button) ? 'block' : 'none')
                );
            }
        });
    }

    _onButtonKeydown(event) {
        if (event.key === 'Tab' && this.isAriaExpanded(event.target) && event.shiftKey)
            this._toggleCollapseButton(event.target);
    }

    _createCollapseButton(ul, sectionTitle, ulId) {
        const button = document.createElement('button');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', ulId);
        button.classList.add('collapsible-button');
        button.setAttribute(
            'aria-label',
            sectionTitle && sectionTitle !== '' ? 'Expand sub menu of section ' + sectionTitle : 'Expand sub menu'
        );
        const icon = document.createElement('i');
        icon.setAttribute('aria-hidden', 'true');
        icon.classList.add(this.config.icon);
        button.appendChild(icon);
        ul.id = ulId;
        return button;
    }

    _hideSubSections() {
        const ulElements = this.sections.querySelectorAll('ul');
        ulElements.forEach(ul => {
            ul.style.height = '0';
            ul.style.overflow = 'hidden';
            ul.setAttribute('aria-hidden', 'true');
            ul.style.display = 'none';
        });
    }

    _toggleCollapseButton(button) {
        this.isAriaExpanded(button) ? this._collapseSubsection(button) : this._expandSubsection(button);
    }

    _collapseSubsection(button) {
        const subsection = button.nextElementSibling;
        subsection.style.height = `${subsection.scrollHeight}px`;
        setTimeout(() => {
            subsection.style.height = '0';
        }, 100);
        subsection.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Collapse', 'Expand'));
        button.setAttribute('aria-expanded', 'false');
    }

    _expandSubsection(button) {
        const subsection = button.nextElementSibling;
        subsection.style.display = 'block';
        subsection.style.height = `${subsection.scrollHeight}px`;
        setTimeout(() => {
            subsection.style.height = 'auto';
        }, 300);
        subsection.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Expand', 'Collapse'));
        button.setAttribute('aria-expanded', 'true');
    }

    isAriaExpanded(button) {
        return button.getAttribute('aria-expanded') === 'true';
    }
}

module.exports = CollapsibleSectionNavigation;
